import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService extends DatabaseGwService {
  URL_PATH: string = "/payment-methods";

}
